export enum VoiceCallRecordCreationEnum {
  ClientSideCallCreation,
  ServerSideCallCreationFromDaVinci,
  ServerSideCallCreationFromIVR
}
